<template>
  <div id="loanFollowup">
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      :title="
        $GetIsAnbohSaz() == 'false'
          ? 'پیگیری درخواست‌های وام'
          : 'پیگیری درخواست‌های واحد'
      "
      :description="
        $GetIsAnbohSaz() == 'false'
          ? 'از طریق این فرم می‌توانید وضعیت درخواست‌های وام خود را پیگیری کنید'
          : 'از طریق این فرم می‌توانید وضعیت درخواست‌های واحد خود را پیگیری کنید'
      "
      :show-back="true"
    >
      <div class="loan-followup-content py-3 px-0" :key="Render">
        <div
          v-if="NeedVamList.length > 0 && !loadingRender"
          class="loan-followup-list"
        >
          <article
            v-for="(item, index) in NeedVamList"
            :key="index"
            class="loan-followup-card"
          >
            <header class="loan-followup-card__top">
              <div class="loan-followup-card__tracking">
                <span class="loan-followup-card__tracking-label">کد رهگیری</span>
                <span class="loan-followup-card__tracking-code">{{
                  item.codeRahgiri
                }}</span>
              </div>
              <div class="loan-followup-card__status">
                <template
                  v-if="
                    $session.get('CustCode') != '932' &&
                    $session.get('CustCode') != '8002'
                  "
                >
                  <span
                    v-if="item.isModirTaeed == 0"
                    class="badge badge-warning loan-followup-badge loan-followup-badge--lg"
                  >
                    <i class="far fa-hourglass"></i> در حال بررسی
                  </span>
                  <span
                    v-else-if="item.isModirTaeed == 1"
                    class="badge badge-success loan-followup-badge loan-followup-badge--lg"
                  >
                    <i class="fas fa-check"></i> تایید شده
                  </span>
                  <span
                    v-else-if="item.isModirTaeed == 2"
                    class="badge badge-danger loan-followup-badge loan-followup-badge--lg"
                  >
                    <i class="fas fa-times"></i> رد شده
                  </span>
                </template>
                <span v-else class="loan-followup-card__status-text">
                  {{ item.wwwtblComboIdVaziyatGrp312Name }}
                </span>
              </div>
            </header>

            <section class="loan-followup-section loan-followup-section--summary">
              <h6 class="loan-followup-section__title">خلاصه درخواست</h6>
              <div class="loan-followup-grid">
                <div class="loan-followup-field">
                  <span class="loan-followup-field__label">
                    {{ $GetIsAnbohSaz() == "false" ? "نوع تسهیلات" : "نوع قرارداد" }}
                  </span>
                  <span class="loan-followup-field__value">{{ item.desNoe }}</span>
                </div>
                <div class="loan-followup-field">
                  <span class="loan-followup-field__label">تاریخ درخواست</span>
                  <span
                    class="loan-followup-field__value loan-followup-field__value--ltr"
                    >{{ item.requestTarix }}</span
                  >
                </div>
                <div class="loan-followup-field">
                  <span class="loan-followup-field__label">
                    {{ $GetIsAnbohSaz() == "false" ? "مبلغ تسهیلات" : "مبلغ قرارداد" }}
                  </span>
                  <span
                    class="loan-followup-field__value loan-followup-field__value--ltr"
                    >{{ $Comma3ragham(item.mablagh) }}</span
                  >
                </div>
                <div class="loan-followup-field">
                  <span class="loan-followup-field__label">مدت باز پرداخت</span>
                  <span
                    class="loan-followup-field__value loan-followup-field__value--ltr"
                  >
                    {{ item.tedadGhest }} قسط
                  </span>
                </div>
                <div
                  v-if="
                    item.sepordeTime != null &&
                    item.sepordeTime != 0 &&
                    item.sepordeTime > 0
                  "
                  class="loan-followup-field"
                >
                  <span class="loan-followup-field__label">مدت سپرده‌گذاری</span>
                  <span
                    class="loan-followup-field__value loan-followup-field__value--ltr"
                  >
                    {{ item.sepordeTime }} ماه
                  </span>
                </div>
              </div>
            </section>

            <div
              v-if="hasExpandableDetails(item)"
              class="loan-followup-card__footer"
            >
              <button
                type="button"
                class="loan-followup-toggle-btn"
                @click="toggleDetails(index)"
              >
                <i
                  class="fas"
                  :class="
                    isExpanded(index)
                      ? 'fa-chevron-up'
                      : 'fa-chevron-down'
                  "
                ></i>
                {{ isExpanded(index) ? "بستن جزئیات" : "مشاهده جزئیات" }}
              </button>
            </div>

            <div v-show="isExpanded(index)" class="loan-followup-details">
              <section
                v-if="$session.get('CustCode') != 932 && getZamenEntries(item).length > 0"
                class="loan-followup-section loan-followup-section--zamen"
              >
                <h6 class="loan-followup-section__title">ضامنین</h6>
                <div class="loan-followup-zamen-list">
                  <article
                    v-for="zamen in getZamenEntries(item)"
                    :key="zamen.num"
                    class="loan-followup-zamen-card"
                  >
                    <header class="loan-followup-zamen-card__header">
                      <span class="loan-followup-zamen-card__badge">{{
                        zamen.num
                      }}</span>
                      <span class="loan-followup-zamen-card__name">
                        {{
                          zamen.isEmpty
                            ? "اطلاعاتی ثبت نشده"
                            : zamen.name
                        }}
                      </span>
                      <button
                        v-if="
                          !zamen.isEmpty &&
                          ($session.get('CustCode') == '259' ||
                            $session.get('CustCode') == '8002')
                        "
                        type="button"
                        class="loan-followup-zamen-edit-btn"
                        title="ویرایش ضامن"
                        @click="
                          EditZamen(
                            zamen.zamenNoId,
                            item.id,
                            zamen.name,
                            item.isModirTaeed,
                            zamen.status,
                          )
                        "
                      >
                        <i class="fa fa-pen"></i>
                      </button>
                    </header>
                    <div class="loan-followup-zamen-card__body">
                      <div class="loan-followup-field loan-followup-field--plain">
                        <span class="loan-followup-field__label">وضعیت تایید</span>
                        <span class="loan-followup-field__value">
                          <span
                            v-if="zamen.isEmpty"
                            class="loan-followup-zamen-card__muted"
                          >
                            —
                          </span>
                          <span
                            v-else-if="zamen.status == 0"
                            class="badge badge-warning loan-followup-badge"
                          >
                            <i class="far fa-hourglass"></i> در حال بررسی
                          </span>
                          <span
                            v-else-if="zamen.status == 1"
                            class="badge badge-success loan-followup-badge"
                          >
                            <i class="fas fa-check"></i> تایید شده
                          </span>
                          <span
                            v-else-if="zamen.status == 2"
                            class="badge badge-danger loan-followup-badge"
                          >
                            <i class="fas fa-times"></i> رد شده
                          </span>
                        </span>
                      </div>
                    </div>
                  </article>
                </div>
              </section>

              <section class="loan-followup-section loan-followup-section--notes">
                <h6 class="loan-followup-section__title">
                  شرح اصلاحات کارشناس
                  {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }}
                </h6>
                <p
                  class="loan-followup-notes"
                  :class="{
                    'loan-followup-notes--empty': !hasCorrectionNote(item),
                  }"
                >
                  {{
                    hasCorrectionNote(item)
                      ? item.sharhEslahatByModir
                      : "اصلاحی ثبت نشده است"
                  }}
                </p>
              </section>
            </div>
          </article>
        </div>

        <div
          v-else-if="!loadingRender"
          class="loan-followup-empty"
        >
          درخواستی برای نمایش وجود ندارد
        </div>
      </div>
    </net-pa-list-page-card>

    <button
      type="button"
      class="d-none"
      id="ShowModal"
      data-toggle="modal"
      data-target="#Modal-light"
    ></button>

    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="loan-followup-modal">
          <div class="btn-Close-Modal">
            <button
              type="button"
              id="CloseModal"
              class="close text-dark"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="alert alert-warning text-center">
            <div>کد ملی ضامن جدید را وارد و سپس روی دکمه استعلام کلیک کنید</div>
            <b class="text-danger d-block mt-2">
              اطلاعات ضامن جدید جایگزین {{ OldZamen.OldZamenName }} می‌شود
            </b>
          </div>
          <div class="loan-followup-modal__input-group">
            <input
              class="form-control loan-followup-modal__input"
              placeholder="کد ملی ضامن"
              v-model="newCodemeli"
              dir="ltr"
            />
            <button
              type="button"
              class="loan-followup-modal__check-btn"
              @click="Estelam"
            >
              استعلام
            </button>
          </div>
          <div v-if="newZamenInfo != null" class="loan-followup-modal__result">
            <span class="loan-followup-field__label">اطلاعات ضامن</span>
            <span class="loan-followup-field__value">{{
              newZamenInfo.nameFamily
            }}</span>
            <div class="loan-followup-modal__result-actions">
              <button type="button" class="btn btn-warning btn-sm" @click="reject">
                حذف
              </button>
              <button type="button" class="btn btn-success btn-sm" @click="addZamen">
                تایید
              </button>
            </div>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>

<script>
import ModalCustom from "../Tools/ModalCustom.vue";
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import Loading from "../Tools/NetPa/Loading.vue";

export default {
  components: { NetPaListPageCard, ModalCustom, Loading },
  data() {
    return {
      loadingRender: false,
      loanFollowup: "loanFollowup",
      NeedVamList: [],
      newCodemeli: null,
      newZamenInfo: null,
      OldZamen: {},
      Render: 0,
      expandedDetails: {},
    };
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      this.loadingRender = true;
      var formdata = new FormData();
      formdata.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxiosNeedVam = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "ListNeedVam",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosNeedVam).then((data) => {
        this.NeedVamList = data;
        this.loadingRender = false;
      });
    },
    isExpanded(index) {
      return !!this.expandedDetails[index];
    },
    toggleDetails(index) {
      this.$set(this.expandedDetails, index, !this.expandedDetails[index]);
    },
    hasCorrectionNote(item) {
      return (
        item.sharhEslahatByModir != null && item.sharhEslahatByModir !== ""
      );
    },
    hasExpandableDetails(item) {
      if (this.$session.get("CustCode") != 932) {
        return true;
      }
      return this.hasCorrectionNote(item);
    },
    getZamenEntries(item) {
      const configs = [
        { key: "zamenName1", status: "zamenIsTaeed1", num: 1, id: 4031 },
        { key: "zamenName2", status: "zamenIsTaeed2", num: 2, id: 4032 },
        { key: "zamenName3", status: "zamenIsTaeed3", num: 3, id: 4033 },
      ];
      return configs
        .filter((c) => item[c.key] != null)
        .map((c) => ({
          num: c.num,
          name: item[c.key],
          status: item[c.status],
          zamenNoId: c.id,
          isEmpty: item[c.key] === "",
        }));
    },
    EditZamen(ZamenNoId, NeedVamId, OldZamenName, IsModirTaeed, ZamenIsTaeed) {
      if (ZamenIsTaeed == 1) {
        this.$mySweetDefaultTost(
          "خطا در ویرایش ضامن",
          "ضامن انتخابی درخواست ضمانت شمارا تایید کرده و امکان ویرایش این ضامن وجود ندارد ",
          "error",
          2200,
        );
        return;
      }
      if (IsModirTaeed != 0) {
        this.$mySweetDefaultTost(
          "خطا در ویرایش ضامن",
          "به دلیل برسی توسط مدیر سامانه و تغییر در وضعیت درخواست امکان ویرایش ضامن وجود ندارد ",
          "error",
          2200,
        );
        return;
      }
      this.OldZamen = {
        NeedVamId: NeedVamId,
        ZamenNoId: ZamenNoId,
        OldZamenName: OldZamenName,
      };
      document.getElementById("ShowModal").click();
    },
    Estelam() {
      if (this.$session.get("UserInfoNetPa").codeMeli.trim() == this.newCodemeli) {
        this.$mySweetDefault("خطا", "شما کد ملی خود را وارد کرده اید", "error", 2000);
        this.newCodemeli = null;
        return;
      }
      if (this.newCodemeli.trim().length < 10 || this.newCodemeli.trim().length > 10) {
        this.$mySweetDefault(
          "خطا",
          " طول کد ملی نمیتواند کمتر یا بیشتر از 10 رقم باشد",
          "error",
          2000,
        );
        return;
      }
      var DataAxiosGetZament = {
        ArryfildValue: "",
        Method: "Post",
        Action: "GetZamenByMelli3Onlione",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formdata.append("CodeMeli", this.newCodemeli);
      DataAxiosGetZament.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosGetZament).then((res) => {
        this.newZamenInfo = res;
      });
    },
    reject() {
      this.newZamenInfo = null;
      this.newCodemeli = null;
    },
    addZamen() {
      var DataAxiosNewZament = {
        ArryfildValue: "",
        Method: "Post",
        Action: "UpdateZamenByMelli",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("NeedVamId", this.OldZamen.NeedVamId);
      formdata.append("tblComboIdNoe10", this.OldZamen.ZamenNoId);
      formdata.append("NewCodeMeli", this.newCodemeli);
      formdata.append("NewMobile", this.newZamenInfo.mobile);
      formdata.append("NewAzaId", this.newZamenInfo.id);
      formdata.append("NewNameFamily", this.newZamenInfo.nameFamily);
      DataAxiosNewZament.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosNewZament).then((res) => {
        if (res.status == "Ok") {
          this.GetData();
          document.getElementById("CloseModal").click();
          this.$mySweetDefault(
            "عملیات موفق",
            "عملیات ویرایش ضامن با موفقیت انجام شد",
            "success",
            2000,
          );
          this.Render++;
        } else {
          this.GetData();
          document.getElementById("CloseModal").click();
          this.$mySweetDefault(
            "عملیات ناموفق",
            " خطایی در ویرایش اطلاعات ضامن به  وجود آمد، لطفا دقایقی دیگر مجدد اقدام کنید",
            "error",
            2000,
          );
          this.Render++;
        }
      });
    },
  },
};
</script>

<style scoped>
.loan-followup-content {
  width: 100%;
}

.loan-followup-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.loan-followup-card {
  overflow: hidden;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(42, 63, 84, 0.06);
}

.loan-followup-card__top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  background: linear-gradient(
    180deg,
    rgba(42, 63, 84, 0.07) 0%,
    rgba(42, 63, 84, 0.03) 100%
  );
  border-bottom: 1px solid #e8ecf1;
  direction: rtl;
}

.loan-followup-card__tracking {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  min-width: 0;
}

.loan-followup-card__tracking-label {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
}

.loan-followup-card__tracking-code {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2a3f54;
  direction: ltr;
  unicode-bidi: isolate;
  line-height: 1.2;
}

.loan-followup-card__status {
  flex-shrink: 0;
}

.loan-followup-card__status-text {
  font-size: 13px;
  font-weight: 700;
  color: #2a3f54;
}

.loan-followup-section {
  margin: 0.85rem 1rem 0;
  padding: 0.85rem 0.95rem;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  background: #fff;
}

.loan-followup-section--summary {
  border-right: 3px solid #007bff;
}

.loan-followup-section--zamen {
  border-right: 3px solid #28a745;
}

.loan-followup-section--notes {
  border-right: 3px solid #ffc107;
}

.loan-followup-section__title {
  margin: 0 0 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #eef1f5;
  font-size: 14px;
  font-weight: 700;
  color: #2a3f54;
  text-align: right;
}

.loan-followup-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0;
}

@media (min-width: 768px) {
  .loan-followup-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 1.25rem;
  }
}

.loan-followup-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
  width: 100%;
  padding: 0.55rem 0;
  border-bottom: 1px solid rgba(42, 63, 84, 0.08);
  direction: rtl;
  text-align: right;
}

.loan-followup-field:last-child {
  border-bottom: none;
}

.loan-followup-field--plain {
  padding: 0.45rem 0 0;
  border-bottom: none;
}

.loan-followup-field__label {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  line-height: 1.5;
  white-space: nowrap;
}

.loan-followup-field__label::after {
  content: ":\00a0";
}

.loan-followup-field__value {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 58%;
  font-size: 14px;
  font-weight: 500;
  color: #2a3f54;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
}

.loan-followup-field__value--ltr {
  direction: ltr;
  unicode-bidi: isolate;
  text-align: left;
}

.loan-followup-badge {
  font-weight: 500 !important;
  font-size: 11px !important;
}

.loan-followup-badge--warning {
  background-color: #ffc107 !important;
  color: #212529 !important;
}

.loan-followup-badge--success {
  background-color: #28a745 !important;
  color: #fff !important;
}

.loan-followup-badge--danger {
  background-color: #dc3545 !important;
  color: #fff !important;
}

.loan-followup-badge--lg {
  font-size: 12px !important;
  padding: 0.45em 0.75em;
}

.loan-followup-card__footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0.65rem 1rem 0.9rem;
  box-sizing: border-box;
}

.loan-followup-toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  flex-shrink: 0;
  padding: 0.4rem 1rem;
  border: 1px solid #dce3eb;
  border-radius: 8px;
  background: #f8faff;
  color: #2a3f54;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.loan-followup-toggle-btn:hover {
  background: #eef3f9;
  border-color: #c5d0dc;
}

.loan-followup-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0 1rem 1rem;
}

.loan-followup-details .loan-followup-section {
  margin: 0;
}

.loan-followup-zamen-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.65rem;
}

@media (min-width: 768px) {
  .loan-followup-zamen-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.loan-followup-zamen-card {
  overflow: hidden;
  border-radius: 10px;
  background: #f8faff;
  border: 1px solid rgba(40, 167, 69, 0.12);
}

.loan-followup-zamen-card__header {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.6rem 0.75rem;
  background: rgba(40, 167, 69, 0.1);
  border-bottom: 1px solid rgba(40, 167, 69, 0.12);
  direction: rtl;
}

.loan-followup-zamen-card__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 1.6rem;
  height: 1.6rem;
  border-radius: 999px;
  background: #28a745;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.loan-followup-zamen-card__name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 700;
  color: #2a3f54;
  word-break: break-word;
  text-align: right;
}

.loan-followup-zamen-card__muted {
  color: #6c757d;
  font-weight: 500;
}

.loan-followup-zamen-card__body {
  padding: 0.35rem 0.75rem 0.65rem;
}

.loan-followup-zamen-edit-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: rgba(42, 63, 84, 0.1);
  color: #2a3f54;
  font-size: 12px;
  cursor: pointer;
}

.loan-followup-zamen-edit-btn:hover {
  background: rgba(42, 63, 84, 0.18);
}

.loan-followup-notes {
  margin: 0;
  padding: 0.75rem 0.85rem;
  border-radius: 8px;
  background: #f8faff;
  color: #2a3f54;
  font-size: 14px;
  line-height: 1.7;
  text-align: right;
  white-space: pre-wrap;
  word-break: break-word;
}

.loan-followup-notes--empty {
  color: #6c757d;
  font-style: normal;
}

.loan-followup-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12rem;
  padding: 1.5rem;
  border-radius: 12px;
  background: #fff8e6;
  color: #856404;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.loan-followup-modal {
  padding: 0.5rem;
}

.loan-followup-modal__input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  margin-top: 0.75rem;
  overflow: hidden;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background: #fff;
  direction: rtl;
}

.loan-followup-modal__input {
  flex: 1 1 auto;
  min-width: 0;
  height: calc(1.5em + 0.75rem + 2px);
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  text-align: left;
}

.loan-followup-modal__check-btn {
  flex: 0 0 auto;
  align-self: stretch;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 5rem;
  padding: 0 0.85rem;
  border: none;
  border-right: 1px solid #ced4da;
  border-radius: 0;
  background: #28a745;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.loan-followup-modal__result {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.85rem;
  padding: 0.75rem;
  border: 1px solid rgba(40, 167, 69, 0.35);
  border-radius: 10px;
  background: rgba(40, 167, 69, 0.08);
  direction: rtl;
}

.loan-followup-modal__result-actions {
  display: flex;
  gap: 0.5rem;
}
</style>
